import React, { useRef, useState } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";

import marginStyles from "../../../../styles/marginstyles.module.css";

import { Label, Hint, Error } from "@progress/kendo-react-labels";
import {
    Input,
    MaskedTextBox,
    NumericTextBox,
    Checkbox,
    ColorPicker,
    Switch,
    RadioGroup,
    Slider,
    SliderLabel,
    RangeSlider,
    TextArea,
    Rating,
  } from "@progress/kendo-react-inputs";

import { validateSkillproficiency } from "../../../../validation/SkillSchedulerValidation";

const ProficiencyDialog = props => {

    const {onCancel, onConfirm} = props;
    const {title, label} = props;

    const proficiencyRef = useRef(0);
    const [errorMessage, setErrorState] = useState("");

    const handleConfirm = () => {
        if (!onConfirm) return;
        if (!handleValidation(proficiencyRef.current.value)) return;
        onConfirm(proficiencyRef.current.value);
    }

    const handleValidation = (value) => {
      try {
        validateSkillproficiency(value)
      } catch (e) {
        setErrorState(e.message);
        return false;
      }
      
      setErrorState("");
      return true;
    }

    return (
        <Dialog title={title} onClose={onCancel}>
            <Label className={marginStyles.mr_10}>{label}</Label>
            <Input
                ref={proficiencyRef}
                name="proficiency"
                type="number"
                min={0}
                max={5}
                step={1}
                style={{width: "200px"}}
            />
            {errorMessage && <Error>{errorMessage}</Error>}
          <DialogActionsBar>
            <Button type="button" onClick={onCancel}>
              Cancel
            </Button>
            <Button type="button" onClick={handleConfirm}>
              Confirm
            </Button>
          </DialogActionsBar>
        </Dialog>
    );
}

export default ProficiencyDialog;